'use strict';

export default {
  navbar: {
    home: {
      title: 'Home',
    },
    dashboard: {
      title: 'Dashboard',
    },
    forms: {
      title: 'Forms',
    },
    settings: {
      title: 'Settings',
      paymentOptions: {
        title: 'Payment',
        name: 'Payment',
      },
      users: {
        title: 'Users',
        name: 'Users',
      },
      reports: {
        title: 'Reports',
      },
      organization: {
        title: 'Organization',
        name: 'Organization',
      },
      notifications: {
        title: 'Notifications',
        name: 'Notifications',
      },
    },
    emptySubMenus: 'No submenus accessible',
  },
};
